"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useCopyToClipboard } from "react-use";
export default function BlockPickerAdvancedItemBlock(t0) {
  const $ = _c(13);
  const {
    block,
    blockParts
  } = t0;
  let parts;
  if ($[0] !== block || $[1] !== blockParts) {
    const number = block.toString();
    const match = blockParts.toString();
    const regex = new RegExp(match, "g");
    parts = [];
    let lastIndex = 0;
    let matchIndex;
    while ((matchIndex = regex.exec(number)) !== null) {
      const matchStart = matchIndex.index;
      const matchEnd = matchIndex.index + matchIndex[0].length;
      if (matchStart > lastIndex) {
        parts.push(number.substring(lastIndex, matchStart));
      }
      parts.push(<span key={matchStart} className="tw-text-error">{number.substring(matchStart, matchEnd)}</span>);
      lastIndex = matchEnd;
    }
    if (lastIndex < number.length) {
      parts.push(number.substring(lastIndex));
    }
    $[0] = block;
    $[1] = blockParts;
    $[2] = parts;
  } else {
    parts = $[2];
  }
  const [, copyToClipboard] = useCopyToClipboard();
  const [coping, setCoping] = useState(false);
  let t1;
  if ($[3] !== block || $[4] !== copyToClipboard) {
    const copy = () => {
      setCoping(true);
      copyToClipboard(block.toString());
      setTimeout(() => setCoping(false), 1000);
    };
    t1 = <FontAwesomeIcon onClick={copy} className="tw-h-5 tw-w-5 tw-cursor-pointer tw-mr-2.5 tw-text-iron-300 hover:tw-text-white tw-transition tw-duration-300 tw-ease-out" icon={faCopy} />;
    $[3] = block;
    $[4] = copyToClipboard;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== block || $[7] !== coping || $[8] !== parts) {
    t2 = coping ? "Copied" : <BlockPickerAdvancedItemBlockLink block={block} blockParts={parts} />;
    $[6] = block;
    $[7] = coping;
    $[8] = parts;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
export function BlockPickerAdvancedItemBlockLink(t0) {
  const $ = _c(3);
  const {
    block,
    blockParts
  } = t0;
  const t1 = `https://etherscan.io/block/countdown/${block}`;
  let t2;
  if ($[0] !== blockParts || $[1] !== t1) {
    t2 = <Link className="tw-underline-offset-2 tw-underline tw-transition tw-duration-300 tw-ease-out" href={t1} target="_blank" rel="noopener noreferrer">{blockParts}</Link>;
    $[0] = blockParts;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}